// https://vuex.vuejs.org/en/modules.html

const requireModule = require.context('.', true, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName === './index.js') return

  // Replace ./ and .js
  const path = fileName.replace(/(\.\/|\.js)/g, '')
  const parts = path.split('/')

  // Standard flat modules (e.g. auth/state, app/mutations)
  if (parts.length === 2) {
    const [moduleName, imported] = parts

    if (!modules[moduleName]) {
      modules[moduleName] = {
        namespaced: true
      }
    }

    modules[moduleName][imported] = requireModule(fileName).default
    return
  }

  // Nested submodules (e.g. cms/main/state)
  if (parts.length === 3) {
    const [moduleName, subModuleName, imported] = parts

    if (!modules[moduleName]) {
      modules[moduleName] = {
        namespaced: true
      }
    }

    if (!modules[moduleName].modules) {
      modules[moduleName].modules = {}
    }

    if (!modules[moduleName].modules[subModuleName]) {
      modules[moduleName].modules[subModuleName] = {
        namespaced: true
      }
    }

    modules[moduleName].modules[subModuleName][imported] = requireModule(fileName).default
  }
})

export default modules
